/** UI10 Plan overview Modal — below Paywall (D20). */
export const ONBOARDING_PLAN_OVERVIEW_MODAL_Z_INDEX = 1050;

/** UI11 Paywall stacks above Plan overview (D20). */
export const ONBOARDING_PAYWALL_MODAL_Z_INDEX = 1100;

export const ONBOARDING_PLAN_OVERVIEW_MODAL_PROPS = {
  zIndex: ONBOARDING_PLAN_OVERVIEW_MODAL_Z_INDEX,
  className:
    "[--modal-radius:0px] [--modal-height:100dvh] [--modal-width:100%]",
  contentStyle: {
    borderRadius: "var(--modal-radius)",
    width: "var(--modal-width)",
    height: "var(--modal-height)",
    maxHeight: "100dvh",
    overflow: "hidden" as const,
    padding: 0,
  },
  styles: {
    body: {
      height: "100%",
      padding: 0,
    },
  },
  containerClassName: "flex h-full flex-col overflow-hidden",
  containerStyle: {
    height: "100%",
    width: "100%",
    maxHeight: "100%",
    overflow: "hidden" as const,
  },
  titleStyle: {
    minHeight: 0,
  },
  showClose: false,
  maskClosable: false,
  destroyOnClose: true,
} as const;
